import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ActivatedRoute, Params } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

import * as HttpStatus from 'http-status-codes';

import { MainService } from './main.service';
import { Helper } from '../helper';
import { Constants } from '../constants';

const _ = require('underscore');

@Injectable()
export class BookingsService {
  API = this.helper.getApi();
  bookings = [];
  clinic: string;
  readonly clinicType = Constants.CLINIC_TYPE;
  readonly bodyPartLabels: any = Constants.BODY_PARTS_LABELS;
  readonly months: any = Constants.MONTHS;

  constructor(
    private http: Http,
    public helper: Helper,
    private route: ActivatedRoute,
    public mainService: MainService
  ) {}

  getBookings(bookingsData: {}, type: String): Observable<any> {
    if (type === this.clinicType.custom) {
      let clinic = null;

      this.route.queryParams.subscribe((params: Params) => {
        if (params['clinics']) {
          clinic = params['clinics'];
          this.clinic = params['clinics'];
        }

        if (params['superClinicId']) {
          clinic = params['superClinicId'];
        }
      });

      const currentUser: any = this.helper.getStorage('currentUser');

      bookingsData = this.helper.getBookingData(
        clinic,
        currentUser.data.complimentaId
      );
    }

    const headerOptions = this.helper.buildAuthHeader();

    return this.http
      .post(
        `${this.API}/users/my-bookings`,
        JSON.stringify(bookingsData),
        headerOptions
      )
      .pipe(
        map((response: Response) => {
          return response.json();
        })
      );
  }

  deleteBooking(booking: {}): Observable<any> {
    const headerOptions = this.helper.buildAuthHeader();

    return this.http.post(
      `${this.API}/api/delete-booking`,
      JSON.stringify(booking),
      headerOptions
    );
  }

  makeBooking(bookingData: any): Observable<any> {
    const headerOptions = this.helper.buildAuthHeader();

    return this.http
      .post(
        `${this.API}/api/book-visit`,
        JSON.stringify(bookingData),
        headerOptions
      )
      .pipe(
        map((response: Response) => {
          return response.json();
        })
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/bookings.service.ts